import { LocationsTranslationCounter } from '@recruitee/http-types';
import { createEntityCollectionStore } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<LocationsTranslationCounter>()('LocationsTranslationCounters', {
    idSelector: item => item.code,
    customActions: adapter => ({
      fetchCollection: (state, payload: { scope: string }) => adapter.markAsPending(state),
    }),
  });

const LocationTranslationCountersActions = {
  fetchCollection: actions.fetchCollection,
  fetchCollectionSuccess: actions.fetchCollectionSuccess,
  fetchCollectionFailed: actions.fetchCollectionFailed,
};

export {
  selectors as LocationTranslationCountersSelectors,
  LocationTranslationCountersActions,
  reducer as LocationTranslationCountersReducer,
  namespace as LocationTranslationCountersNamespace,
};
